import { getLanguage } from '@citrite/translate';
import { LocaleKeys } from '@sharefiledev/fileviewer-pilet-sdk';

export const getCustomWatermarkingLabels = (
	t: (str: LocaleKeys, opts?: any) => string
) => [
	createLabelOverride(
		'WatermarkCheckBox.AddWatermark',
		t('WatermarkCheckBox.AddWatermark')
	),
	createLabelOverride(
		'WatermarkCheckBox.FailedToCreateWatermarkResource',
		t('WatermarkCheckBox.FailedToCreateWatermarkResource')
	),
	createLabelOverride(
		'WatermarkCheckBox.FailedToDeleteWatermarkResource',
		t('WatermarkCheckBox.FailedToDeleteWatermarkResource')
	),
	createLabelOverride(
		'WatermarkCheckBox.NoResourcesProvidedError',
		t('WatermarkCheckBox.NoResourcesProvidedError')
	),
	createLabelOverride(
		'WatermarkCheckBox.NoWatermarkedRidsProvidedError',
		t('WatermarkCheckBox.NoWatermarkedRidsProvidedError')
	),
	createLabelOverride(
		'WatermarkCheckBox.ResourceNotSupportedError',
		t('WatermarkCheckBox.ResourceNotSupportedError')
	),
];

export function createLabelOverride(key: LocaleKeys, value: string) {
	const userLanguage = getLanguage();
	return {
		key,
		value: {
			[userLanguage]: value,
		},
	};
}
